import * as React from "react";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import MultiSelectList from "../../../hiberUiKit/src/molecules/MultiSelectList/MultiSelectList";
import {ColumnDefinition} from "../../../model/workspace/ColumnDefinition";
import {ViewColumn} from "../../../model/workspace/ViewColumn";

interface IProps {
	columns: ViewColumn[];
	onChange: (columns: ViewColumn[]) => void;
	dropDownMenuVisible?: boolean;
	onDropdownMenuVisibilityChange: (dropDownMenuVisible: boolean) => void
}


export default class TableColumnSelector extends React.PureComponent<IProps> {

	constructor(props: IProps) {
		super(props);

		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<div style={{position: "relative", float: "right"}}>
				<span onClick={() => this.props.onDropdownMenuVisibilityChange(true)} className={"a-pointer"}>
					<i className={"fa fa-fw fa-caret-down"}/>
				</span>
				{this.props.dropDownMenuVisible &&
				<DropDownWrapper onOutsideClick={() => this.props.onDropdownMenuVisibilityChange(false)}>
					<MultiSelectList itemToLabel={(item: ViewColumn) => item.columnDefinition.label}
									 itemToId={(item: ViewColumn) => item.id}
									 items={this.props.columns}
									 selectedItemIds={this.props.columns.filter(c => c.visible).map(i => i.id)}
									 onUpdate={this.onChange}
									 updateOnChange/>
				</DropDownWrapper>}
			</div>
		)
	}

	onChange(selectedColumns: ColumnDefinition[]) {
		this.props.onChange(
			this.props.columns.map(c => c.copy({visible: !!selectedColumns.filter(sc => sc.id === c.id).length})));
	}
}